

// Action Types
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const SET_CONNECTION = 'SET_CONNECTION';
export const DISCONNECT_CONNECTION = 'DISCONNECT_CONNECTION';

// Action Creators

export const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  payload: user,
  
});

// add logout
export const logout = () => ({
  type: LOGOUT,
});
// set WEBRTC in video call

export const setConnection = (connection) => ({
  type: SET_CONNECTION,
  payload: connection,
});
// disconnect call connection
export const disconnectConnection = (connection) => ({
  type: DISCONNECT_CONNECTION,
});
// Thunk Action
export const loginUser = (credentials) => async (dispatch) => {
  try {
    const user='';
    dispatch(loginSuccess(user));
  } catch (error) {
    console.log('Login failed:', error.message);
  }
};